<template>
    <section class="company-reviews">
      <h2>Conheça alguns de nossos cases de sucesso</h2>
      <p class="subtitle">
        O que nossos clientes falam de nós
      </p>
  
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="{ id, name, image, comment, person } in testimonials" :key="id" class="swiper-slide">
            <div class="testimonial-card" @click="openDialogFullReview(comment, person)">
              <div class="testimonial-header">
                <img :src="image" :alt="name" class="avatar">
              </div>
              <span class="testimonial-text" v-text="comment" />
              <button class="see-more">Ler mais</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>

  <script setup>
  import { onMounted } from 'vue'

  const testimonials = [
    {
      id: 1,
      image: "https://flip.net.br/wp-content/uploads/2023/02/telhanorte-col-2.png",
      name: "TelhaNorte",
      person: {
        img: "https://flip.net.br/wp-content/uploads/2025/02/review-telhanorte.webp",
        position: "Gerente de inteligência de mercado na Telhanorte",
        name: "Ricardo Hamad"
      },
      description: "Usa a plataforma a 3 anos",
      comment: `
        “O Flipnet tem desempenhado um papel essencial na gestão do nosso programa de relacionamento com profissionais especificadores. A plataforma tornou muito mais simples aos participantes consultarem e resgatarem seus pontos, o que contribuiu diretamente para aumentar a satisfação e o engajamento deles com o programa.
        A automação de processos que antes eram parcialmente manuais, como o acompanhamento de resgates e a atualização de extrato de pontos, trouxe mais agilidade e produtividade para a nossa equipe, permitindo que nos concentremos em ações mais estratégicas.
        Por fim, gostaria de destacar a disponibilidade do suporte da Flipnet, que sempre nos atende com prontidão e resolve nossas solicitações de forma ágil e eficiente. Além disso, a equipe tem se mostrado um verdadeiro parceiro estratégico, compartilhando ideias e sugestões valiosas com base na sua ampla experiência no mercado de fidelidade e afiliados."
      `
    },
    {
      id: 2,
      image: "https://flip.net.br/wp-content/uploads/2025/01/brae-logo-2.png",
      name: "Braé",
      person: {
        img: "https://flip.net.br/wp-content/uploads/2025/02/review-brae.webp",
        position: "Project Owner na Braé",
        name: "Jorge Mello"
      },
      description: "Usa a plataforma à 6 meses",
      comment: `
      “Com certeza, grande parte das razões pelas quais podemos atribuir os resultados obtidos, foram por conta do Flip.
      Uma das partes mais legais é a gestão dos pagamentos das comissões. Através da própria plataforma, o afiliado pode enviar sua nota fiscal para receber a comissão, e o Flip cuida de todo este processo!
      Além disso, a plataforma permite um método de gamificação muito eficaz, classificando os afiliados em níveis de acordo com os critérios que escolhermos, criação de missões - que podem ser entendidas como campanhas - customizáveis, com diversas possibilidades.
      Falando sobre Reports e dados, a plataforma conta com uma versão para administradores super completa, onde podemos ver detalhadamente todos os dados dos afiliados, gráfico diário de performance de vendas, taxa de conversão, vendas, acessos no site e muito mais!
      Mas acima de tudo, o maior sucesso na plataforma, na visão dos afiliados, é o suporte do Flip para dúvidas, dificuldades técnicas, entre outros."
      `
    },
    {
      id: 3,
      image: "https://flip.net.br/wp-content/uploads/2025/01/vivavinho-logo.png",
      name: "Vivavinho",
      person: {
        img: "https://flip.net.br/wp-content/uploads/2025/02/review-vivavinho.png",
        position: "Ecommerce Vivavinho",
        name: "Lucas"
      },
      description: "Usa a plataforma à 5 meses",
      comment: `
        “A parceria com o Flipnet tem sido extremamente produtiva, ajudando-nos a gerenciar nossa base de parceiros de forma eficiente, graças a uma plataforma intuitiva e prática. As integrações com canais de comunicação são um diferencial, tornando nosso trabalho mais ágil e fortalecendo a conexão com nossos parceiros.
        Estamos juntos há quase dois anos, e nesse período alcançamos um aumento expressivo nos resultados com afiliados. Não posso deixar de destacar o setor de suporte, sempre solícito e proativo, que nos auxilia tanto na solução de questões técnicas quanto no desenvolvimento de estratégias. O Flipnet, sem dúvida, é uma parceira essencial para o nosso crescimento."
      `
    }
  ]

  const openDialogFullReview = (comment, person) => {
    const data = {
      type: 'companyReviews', // Tipo de evento
      person: person, 
      comment: comment 
    };

    window.parent.postMessage(data, 'https://flip.net.br');
  }
  
  const initializeSwiperReviews = () => {
    setTimeout(() => {
      new window.Swiper('.swiper-container', {
        slidesPerView: 1.1,
        breakpoints: {
          768: {
            slidesPerView: 1.4,
          },
          980: {
            slidesPerView: 2.4,
          },
          1420: {
            slidesPerView: 3,
          }
        },
        spaceBetween: 30,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }) 
    });
  }

  // Adiciona a biblioteca do swiperJS ( https://swiperjs.com/ )
const addSwiper = () => {
    const link = document.createElement('link');
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    link.rel = 'stylesheet';

    document.head.appendChild(link);

    const script = document.createElement('script');
    script.id = 'swiper-element'
    script.async = true
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

    document.body.appendChild(script);

    // Aguarda o swiper ser 100% carregado para criar os swipers nos componentes que precisam dele
    script.onload = () => {
      initializeSwiperReviews()
    }
}

onMounted(() => addSwiper())
  </script>
 <style scoped>
 .company-reviews {
   padding: 38px 20px;
   background: rgba(255, 86, 161, 0.06);
   color: white;
   overflow: hidden
 }
 
 h2 {
   font-size: max(28px,min(5vw,40px));
   line-height: 1.1;
   font-weight: 400;
   text-align: center;
   margin: 0px;
   color: #000
 }
 
 .subtitle {
   margin-top: 1rem;
   color: #5e5e5e;
   margin-bottom: 3rem;
   text-align: center;
   line-height: 1.2;
   font-size: clamp(20px, 4vw, 24px);
   font-weight: 300;
 }

 button.see-more {
  outline: none;
  border: none;
  background: transparent;
  margin-left: auto;
  color: #000;
  text-decoration: underline;
  margin-top: 0.4rem;
  cursor: pointer;
  font-size: clamp(0.8rem, 3.5vw, 0.9rem);
 }

 .q-img {
  max-width: 64px;
  margin-left: 0.1rem
 }
 
 .swiper-container {
   margin: 0 auto;
   max-width: 1167px;
 }

 .testimonial-card {
   display: grid;
   background-color: rgba(255, 255, 255, 0.1);
   backdrop-filter: blur(10px);
   border-radius: 1rem;
   padding: 1.5rem;
   height: 100%;
   border: 1px solid rgba(255, 255, 255, 0.2);
   box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
   max-width: 520px;
 }
 
 .testimonial-header {
   display: grid;
   justify-content: center;
   align-items: center;
   gap: 0.6rem;
   margin-bottom: 1.5rem;
   height: 2rem;
 }
 
 .avatar {
   margin: 0 auto;
   max-width: 110px;
 }
 
 .testimonial-info h3 {
   font-size: 1rem;
   line-height: 1;
   text-align: center;
   font-weight: 500;
   margin: 0px 0px 0.1rem 0px;
   color: #000;
 }
 
 .testimonial-info span {
   margin: 0;
   font-size: 0.85rem;
   color: rgba(255, 255, 255, 0.7);
 }
 
 .testimonial-text {
  font-size: clamp(16px,3.5vw,18px);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 300;
  text-overflow: ellipsis;
  height: 6em;  
  line-height: 1.5em;
  text-align: center;
  color: #000;
 }
 
 :deep(.swiper-pagination-bullet) {
   background: #4ade80;
 }
 
 :deep(.swiper-button-next),
 :deep(.swiper-button-prev) {
   color: #4ade80;
 }

 @media ( min-width: 768px ) {
   .company-reviews {
     padding: 4rem 0px 4rem 1rem;
   }

   .testimonial-card {
     padding: 2rem;
   }

   .testimonial-info h3 {
     text-align: left;
   }

   .testimonial-text {
     text-align: left;
   }
   
   .avatar {
     margin: 0px
   }

   .subtitle {
     margin-top: 0.2rem;
   }
 }
 </style>